import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDynamicFormValue } from 'src/lib';
import { IAsIsToBeState } from '../types/as-is-to-be-state.model';
import {
  getLocalFiltersData,
  getGridDataForAsAndToBe
} from './simulator-summary-slice-async-thunks';

const initialState: IAsIsToBeState = {
  fetchingLocalFiltersData: false,
  localFilterFormFields: [],
  localFilterInitialValues: {},
  localFilterValue: {},
  colorGradientMap: {
    ppg: {
      mac_mapping: {},
      min: 0,
      max: 0
    },
    sku: {
      mac_mapping: {},
      min: 0,
      max: 0
    }
  },
  fetchingGridData: false,
  asIs: {
    column_headers: [],
    grid_data: [],
    row_headers: []
  },
  toBe: {
    column_headers: [],
    grid_data: [],
    row_headers: []
  }
};

const asIsToBeSlice = createSlice({
  name: 'as-is-to-be-slice',
  initialState,
  reducers: {
    resetGridMetrics(state) {
      state.localFilterInitialValues =
        state.localFilterFormFields.reduce<IDynamicFormValue>(
          (prev, curr) => ({ ...prev, [curr.name]: curr.default_value }),
          {}
        );
    },
    setLocalFilterValueInSummary(
      state,
      action: PayloadAction<IDynamicFormValue>
    ) {
      state.localFilterValue = action.payload;
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getLocalFiltersData.pending, (state) => {
        state.fetchingLocalFiltersData = true;
      })
      .addCase(getLocalFiltersData.fulfilled, (state, action) => {
        state.fetchingLocalFiltersData = false;
        const { fields, values } = action.payload;
        state.localFilterFormFields = fields;
        state.localFilterInitialValues = values;
        state.localFilterValue = values;
      })
      .addCase(getLocalFiltersData.rejected, (state) => {
        state.fetchingLocalFiltersData = false;
      })
      .addCase(getGridDataForAsAndToBe.pending, (state) => {
        state.fetchingGridData = true;
        state.asIs = {
          column_headers: [],
          grid_data: [],
          row_headers: []
        };
        state.toBe = {
          column_headers: [],
          grid_data: [],
          row_headers: []
        };
      })
      .addCase(getGridDataForAsAndToBe.rejected, (state) => {
        state.fetchingGridData = false;
        state.asIs = {
          column_headers: [],
          grid_data: [],
          row_headers: []
        };
        state.toBe = {
          column_headers: [],
          grid_data: [],
          row_headers: []
        };
      })
      .addCase(getGridDataForAsAndToBe.fulfilled, (state, action) => {
        state.fetchingGridData = false;
        const { colorGradient, asIs, toBe } = action.payload;
        state.colorGradientMap = colorGradient;
        state.asIs = asIs;
        state.toBe = toBe;
      })
});

export const { resetGridMetrics, setLocalFilterValueInSummary } =
  asIsToBeSlice.actions;

export default asIsToBeSlice;
